<template>
  <div>
    <contacts
      :associatedcontacts="selectedContacts"
      :isloading="isLoading"
      @contacts="fetchContacts()"
    ></contacts>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import Contacts from "@/components/Contacts.vue";
import AssociatedContacts from "@/components/Contacts.vue";

export default {
  components: {
    Contacts: Contacts,
    associatedcontacts: AssociatedContacts
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/contacts'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  data() {
    return {
      isLoading: true,
      selectedContacts: []
    };
  },
  watch: {
    contacts()  {
      this.contacts = fetchContacts()
    },
    dialog(val) {
      val || this.close();

  },
   search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.contacts= await this.searchContact(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  
  computed: {},
  

  methods: {
    searchContact(search){
      if(search.search!==""){      
        Api()
        .get('/contacts',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.contacts=response.data
        })} 
      },
    fetchAllContacts(){
      this.isLoading=true
          Api()
          .get('/contacts/active')
          .then(response=>{
              this.selectedContacts=response.data,
              this.isLoading=false
          });
      },
      fetchContactsByCustomer(customerId){
        this.isLoading=true
        
          Api()
          .get('/customercontact/showByCustomer/'+customerId)
          .then(response=>{
            this.selectedContacts=[]
               for (var i = 0; i < response.data.length; i++) {
                            let tempContactToPush = response.data[i].contact;
                            (this.selectedContacts).push(tempContactToPush);
                        }
                        this.isLoading=false
          });
      },
      
    initialize() {
          this.fetchAllContacts()

    },
    fetchContacts() {
      this.isLoading=true
        this.fetchAllContacts()
    },
    editItem(item) {
      this.editedIndex = this.contacts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

      deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/contacts/" + id, {
          isActive: false,
          isDeleted: true
        });
        this.fetchContacts();
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
       if(!this.sizeValidation(this.image.length)){
            alert('File size exceeds 20 kB, please select a smaller profile picture');
             this.image = '';
        }
        else{
       
       Api().put("/files" + this.editedItem.id, {
        fileName: this.editedItem.name + ' Profile Image',
        fileData: this.image,
        fileType: this.imageInput.type,
        isActive: true
      })
       .then(response => {
         this.editedItem.fileId = response.data.id
        });

      Api().put("/contacts/" + this.editedItem.id, {
        name: this.editedItem.name,
        surname: this.editedItem.surname,
        idNumber: this.editedItem.idNumber,
        mobileNumber: this.editedItem.mobileNumber,
        telephoneNumber: this.editedItem.telephoneNumber,
        emailAddress: this.editedItem.emailAddress,
        password: this.editedItem.password,
        isActive: this.editedItem.isActive,
        fileId: this.editedItem.fileId
      })
       .then(response => {
         this.editedItem.fileId = response.data.id
        });
      this.$emit("contactsSaved");
      this.close();
      this.fetchContacts();
      Object.assign(this.contacts[this.editedIndex], this.editedItem);
    }},
    saveNew() {
        if(!this.sizeValidation(this.image.length)){
            alert('File size exceeds 20 kB, please select a smaller profile picture');
             this.image = '';
        }
        else{  
       Api().post("/files", {
        fileName: this.editedItem.name + ' Profile Image',
        fileData: this.image,
        fileType: this.imageInput.type,
        isActive: true
      })
       .then(response => {
         this.editedItem.fileId = response.data.id 
         this.saveContact();
        });
      }
    }
    },
    saveContact() {
      Api().post("/contacts", {
        name: this.editedItem.name,
        surname: this.editedItem.surname,
        idNumber: this.editedItem.idNumber,
        mobileNumber: this.editedItem.mobileNumber,
        telephoneNumber: this.editedItem.telephoneNumber,
        emailAddress: this.editedItem.emailAddress,
        password: this.editedItem.password,
        fileId: this.editedItem.fileId
      })
      this.$emit("contacts");
      this.close();
      this.fetchContacts();
    }
  
};
</script>
  
